import _map from 'lodash/map';
import _values from 'lodash/values';
import _omit from 'lodash/omit';
import { SelectInput, RenderConfig } from 'commons-ui';
import { FORM_FIELD_KEYS_USER_LEVEL_UPDATE } from '../utils/formConfig';
import { USER_LEVELS } from '../utils/constants';

export const useFormConfig = (currentUserLevel: number) => {
	const FORM_FIELD_CONFIG_USER_LEVEL_UPDATE = {
		[FORM_FIELD_KEYS_USER_LEVEL_UPDATE.USER_LEVEL]: new RenderConfig()
			.setName('userLevel')
			.setLabel('User level')
			.setRenderer(SelectInput)
			.setRenderProps({
				isEditable: { create: true, edit: true },
				required: true,
				options: _map(_values(_omit(USER_LEVELS, currentUserLevel)), (userLevel) => ({ id: userLevel, label: userLevel }))
			})
	};

	return { FORM_FIELD_CONFIG_USER_LEVEL_UPDATE };
};
